import { render, staticRenderFns } from "./payType.vue?vue&type=template&id=85212598&scoped=true&"
import script from "./payType.vue?vue&type=script&lang=ts&"
export * from "./payType.vue?vue&type=script&lang=ts&"
import style0 from "./payType.vue?vue&type=style&index=0&id=85212598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85212598",
  null
  
)

export default component.exports